<template>
    <div class="page-content page-content-full">
        <h1>Error</h1>
        <p>Something has gone wrong.</p>
        <router-link to="/" class="button button-primary">Back</router-link>
    </div>
</template>
<script>
    export default {
        name: 'ErrorView'
    }
</script>
